<template>
  <div>
    <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
      <div>
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item has-feedback label="Module" prop="module">
            <a-select
              placeholder="Choose module"
              style="width: 100%;"
              v-model="form.module"
              :disabled="true"
            />
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            label="Days Added Default In Deadline"
            prop="daysAddedDefaultInDeadline"
          >
            <a-input-number
              v-model="form.daysAddedDefaultInDeadline"
              placeholder="Số ngày mặc định cộng thêm vào deadline..."
              :formatter="
                (value) =>
                  +value >= 0
                    ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    : undefined
              "
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              style="width: 100%;"
            />
          </a-form-model-item>
          <a-form-model-item label="Remind Before" prop="remindBefore">
            <a-input-number
              v-model="form.remindBefore"
              placeholder="Số ngày thông báo trước deadline..."
              :formatter="
                (value) =>
                  +value >= 0
                    ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    : undefined
              "
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              style="width: 100%;"
            />
          </a-form-model-item>
        </a-form-model>

        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button
            @click="closeDrawerUpdateReminder"
            style="margin-right: 5px;"
          >
            Close
          </a-button>
          <a-button
            type="primary"
            @click="updateReminder"
            :loading="loadingUpdate"
          >
            Update
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import getQuery from "../../data/getData";
import postQuery from "../../data/postData";
export default {
  props: {
    updateReminderOnView: {
      type: Function,
      default: null,
    },

    closeDrawerUpdateReminder: {
      type: Function,
      default: null,
    },
    moduleName: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      loadingUpdate: false,
      loadingDelete: false,
      visible: false,
      form: {
        daysAddedDefaultInDeadline: null,
        remindBefore: null,
      },
      rules: {
        daysAddedDefaultInDeadline: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
        remindBefore: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
      },
    };
  },

  methods: {
    getReminder() {
      this.$apollo
        .query({
          query: getQuery.getAppConfigReminderByModuleName,
          fetchPolicy: "no-cache",
          variables: {
            moduleName: this.moduleName,
          },
        })
        .then(({ data }) => {
          this.form = { ...data.getAppConfigReminderByModuleName };
          this.loading = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Không lấy được chi tiết cấu hình",
          });
          console.log("Không lấy được chi tiết cấu hình", error);
        });
    },
    updateReminder() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          this.$apollo
            .mutate({
              mutation: postQuery.updateAppConfigReminder,
              fetchPolicy: "no-cache",
              variables: {
                daysAddedDefaultInDeadline: this.form
                  .daysAddedDefaultInDeadline,
                remindBefore: this.form.remindBefore,
                id: this.id,
              },
            })
            .then(({ data }) => {
              if (data?.updateAppConfigReminder) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Cập nhật cấu hình thành công",
                });
                this.form = { ...data.updateAppConfigReminder };
                this.updateReminderOnView(data?.updateAppConfigReminder);
                this.closeDrawerUpdateReminder();
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Cập nhật cấu hình không thành công",
              });
              console.log("Không cập nhật được cấu hình", error);
              this.loadingUpdate = false;
            });
        } else {
          return false;
        }
      });
    },
  },

  created() {
    this.getReminder();
  },
};
</script>
<style></style>
